"use strict";

/**
 * services controllerの複数箇所で使用する処理をまとめたオブジェクト
 */
export const ServicesCommon = {
  touchStartTime: 0,
  touchEndTime: 0,

  /**
   * サービス画像モーダルの矢印以外をタップ/クリックした時に、条件に応じてモーダルを閉じる
   */
  onTouchServiceImageModal() {
    document.addEventListener(
      "click",
      (e) => {
        // クリック、タッチイベントが同時に動く場合があるのでスキップする
        if (this.touchEndTime && Date.now() - this.touchEndTime < 300) {
          return;
        }
        this.closeServiceImageModal(e);
      },
      true
    );

    document.addEventListener("touchstart", (tsEvent) => {
      this.touchStartTime = Date.now();
      let moveX = 0;
      let touchStartX = tsEvent.touches[0].clientX;

      // スワイプの移動量を取得
      const touchMoveHandler = (tmEvent) => {
        moveX = tmEvent.touches[0].clientX - touchStartX;
      };

      const touchEndHandler = (teEvent) => {
        this.touchEndTime = Date.now();

        // スワイプの移動量が閾値未満の場合はモーダルを閉じる
        if (Math.abs(moveX) < 30) {
          this.closeServiceImageModal(teEvent);
        }
        document.removeEventListener("touchmove", touchMoveHandler);
        document.removeEventListener("touchend", touchEndHandler);
      };

      document.addEventListener("touchmove", touchMoveHandler, { passive: true });
      document.addEventListener("touchend", touchEndHandler);
    });
  },

  /**
   * サービス画像モーダルを閉じる
   *
   * @param {Event} event クリックまたはタッチイベント
   */
  closeServiceImageModal(event) {
    const $target = $(event.target);
    const $arrow = $target.closest(
      "#serviceImgModal .slick-prev, #serviceImgModal .slick-next, #serviceImgModal .slick-arrow"
    );
    const $image = $target.closest("#serviceImgModal .slick-slide img");
    const $imageSingle = $target.closest("#serviceImgModal .modal_singleImg img");

    if ($arrow.length > 0) {
      // 矢印クリックの場合、イベントの伝播のみを停止し、デフォルトの動作は許可する
      event.stopPropagation();
      return; // ここで処理を終了
    }

    if ($image.length > 0 || $imageSingle.length > 0 || !$target.closest("#serviceImgModal").length) {
      $("#serviceImgModal").modal("hide");
    }
  },
};
